import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgOpleveringSleutel = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F8BADD"
      fillRule="evenodd"
      d="m8 14 12-8 12 8v20H8z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m14.875 12.4-8.6 5.97-.57-.82 8.6-5.97z"
      clipRule="evenodd"
    />
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="m21.8 21.39-11.6 4.22 2.05 5.64L16 29.88 15.33 28l7.84-2.85a6 6 0 1 0-1.37-3.76"
      clipRule="evenodd"
    />
    <path
      fill="#F8BADD"
      d="M27.8 23.34a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
    />
    <path
      fill="#15265A"
      d="M21.49 23.65a6 6 0 1 0 6-6v1a5 5 0 1 1-5 5z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgOpleveringSleutel);

export default ForwardRef;
